module.exports = __webpack_public_path__ + "img/place-icon.52d12224.svg";